import React, { memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, bool, func, instanceOf, number, oneOfType, shape, string } from 'prop-types'

import Card from './Components/Card/Card'
import UploadedModelCard from './Components/UploadedModelCard/UploadedModelCard'

const idType = oneOfType([string, number])

function Grid({
  variations,
  uploadedAsset = null,
  isUploadedModelLoaded,
  openedModelId = null,
  mainRunId = null,
  positionById,
  isActionLoading,
  canOpenRelatedTab = false,
  isWide = false,
  showInfo = false,
  onSetAsMain: handleSetAsMain,
  onDelete: handleDelete,
}) {
  return (
    <div className={classnames('variations-tab__grid', isWide && 'variations-tab__grid--wide')}>
      {uploadedAsset && <UploadedModelCard asset={uploadedAsset} isActive={isUploadedModelLoaded} />}
      {variations.map((variation) => (
        <Card
          key={variation.id}
          variation={variation}
          position={positionById.get(String(variation.id))}
          isActive={!isUploadedModelLoaded && String(variation.id) === String(openedModelId)}
          isMain={mainRunId != null && String(variation.id) === String(mainRunId)}
          isActionLoading={isActionLoading}
          canOpenRelatedTab={canOpenRelatedTab}
          showInfo={showInfo}
          onSetAsMain={handleSetAsMain}
          onDelete={handleDelete}
        />
      ))}
    </div>
  )
}

Grid.propTypes = {
  variations: arrayOf(shape({ id: idType.isRequired })).isRequired,
  uploadedAsset: shape({
    assetId: idType,
    fileUrl: string,
    previewUrl: string,
  }),
  isUploadedModelLoaded: bool.isRequired,
  openedModelId: idType,
  mainRunId: idType,
  positionById: instanceOf(Map).isRequired,
  isActionLoading: bool.isRequired,
  canOpenRelatedTab: bool,
  isWide: bool,
  showInfo: bool,
  onSetAsMain: func.isRequired,
  onDelete: func.isRequired,
}

export default memo(Grid)
